jQuery(document).ready(function ($) {


    //$('.menu').dropit();


    //$( '.swipebox' ).swipebox();

    $('.mh-item').matchHeight();


    $('.featureBox__item').matchHeight();

    $('.cardSml__item').matchHeight();

    $('.formImg__item').matchHeight({
        byRow: false
    });

    /*$('.iconBox__img').matchHeight({
        byRow: false
    });*/


    $('.actionRow__item').matchHeight({
        byRow: false
    });


    $('.toolBox').matchHeight({
        byRow: false
    });


    $('.bigBlock').matchHeight({
        byRow: false
    });


    $('.bubbleBox__quote').matchHeight();


    $('.imgCon__item').matchHeight();


    $('.bigBlock__inner').matchHeight({
        target: $('.bigBlock')
    });






});